import pc from 'picocolors';

export interface Logger {
  info: (message: string, ...args: any[]) => void;
  success: (message: string, ...args: any[]) => void;
  warn: (message: string, ...args: any[]) => void;
  error: (message: string, ...args: any[]) => void;
  debug: (message: string, ...args: any[]) => void;
  log: (message: string, ...args: any[]) => void;
}

class ConsoleLogger implements Logger {
  private isDebug = process.env.DEBUG === 'true';

  info(message: string, ...args: any[]) {
    console.log(pc.blue('ℹ'), message, ...args);
  }

  success(message: string, ...args: any[]) {
    console.log(pc.green('✓'), message, ...args);
  }

  warn(message: string, ...args: any[]) {
    console.warn(pc.yellow('⚠'), message, ...args);
  }

  error(message: string, ...args: any[]) {
    console.error(pc.red('✖'), message, ...args);
  }

  debug(message: string, ...args: any[]) {
    if (this.isDebug) {
      console.log(pc.gray('●'), pc.gray(message), ...args);
    }
  }

  log(message: string, ...args: any[]) {
    console.log(message, ...args);
  }
}

export const logger = new ConsoleLogger();